let cartListenerAttached = false;
let membershipInitialised = false;

function initialiseMembershipStore(container) {
  if (!window.Alpine || typeof window.Alpine.store !== 'function') {
    return;
  }

  const membershipStore = window.Alpine.store('membership');
  if (!membershipStore) {
    return;
  }

  if (typeof membershipStore.init === 'function') {
    membershipStore.init();
    return;
  }

  membershipStore.membershipContainer = container;
  membershipStore.loginForm = container.querySelector('#customer_login');
  membershipStore.passwordRecoverForm = container.querySelector('#password_recover');
}

function prepareMembershipModal() {
  if (membershipInitialised) {
    return;
  }

  const container = document.querySelector('.membership-modal__container');
  if (!container) {
    return;
  }

  const sectionRoot = container.closest('[id^="shopify-section-"]') || container;

  if (window.Alpine) {
    const initTree = window.Alpine.initTree || window.Alpine.initializeTree;
    if (typeof initTree === 'function') {
      initTree(sectionRoot);
    }
  }

  initialiseMembershipStore(container);
  membershipInitialised = true;
}

export function ensureMembershipModalLoaded() {
  if (typeof window === 'undefined') {
    return;
  }

  const run = () => {
    prepareMembershipModal();

    if (!cartListenerAttached) {
      document.addEventListener('cart:open', prepareMembershipModal);
      cartListenerAttached = true;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
}
